import DefaultView from 'nette-base-module/js/views/default'
import merge from 'lodash/merge'
import imageSizeUrl from 'nette-media-module/js/utils/imageSizeUrl'

export default merge({
  methods: {
    imageSizeUrl
  }
}, DefaultView)
